import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonItem, IonLabel,
   IonList,
   IonIcon,
   IonRow,
   IonCol,
   IonSpinner,
   IonButton,
   IonGrid,
   IonAvatar,
   useIonAlert
} from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
//import { useParams } from 'react-router';
import ServerService from '../../../services/Server';
import Util from '../../../services/Util';
import { checkmarkCircle, chevronDown, chevronForward, refresh, refreshOutline } from 'ionicons/icons';
import { withRouter } from "react-router";
import './Workflows.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import ImageWithAuth from '../../../components/ImageWithAuth';

const JSON5 = require("json5")

const Workflows: React.FC = () => {

 // const { name } = useParams<{ name: string; }>();
 const name:string = "Workflows";

 const history = useHistory();

 const [presentAlert] = useIonAlert();

 //const [errColor, setErrColor] = useState("danger");
 //const [btnDis, setBtnDis] = useState(false);

 const [loading, setLoading] = useState(true);
 
 const [info, setInfo] = useState({
  sepColor:"",
  inpLbl:""
});

const server = new ServerService();
var state = server.state;

const util = new Util();

type FormType = { info:any };

var goBack = false;

const okBtn = 
{
  side: 'end',
  icon: checkmarkCircle,
  text: 'OK',
  role: 'cancel',
  handler: () => {
    //setBtnDis(false);
//    setErrColor("danger");
    console.log("OK goBack:"+goBack);
    if(goBack) {
      goBack = false;
      history.push("/page/home/workflows")
    }
  }
}

const refreshBtn = {
  text:'Refresh',
  icon: refreshOutline,
  handler: () => {
    //setBtnDis(false);
//    setErrColor("danger");
    window.location.reload();
  }
}

const [panels, setPanels] = useState({});

const showError = (opt:any) => {
  presentAlert({
    header: 'Error',
    message: opt.msg,
    buttons: opt.btns ? opt.btns : [okBtn],
    backdropDismiss: false
  })
}

const doFetchDtls = async function(state:any, retry:boolean) {
  console.log("doFetchWorkflows()");
  setLoading(true);

  var timeout = true;
  setTimeout(()=>{
    if (timeout) {
      console.log("err timeout");
      setLoading(false);
      showError({msg:"Please check Internet Connection!",btns:[okBtn, refreshBtn]});
//      setErrColor("dark");
    }
  },4000)

  const data = {}
  const res = await fetch(server.getFullUrl("mb/workflow/list", data),server.getRequest())
  .then(res => res.json()
  .then(async res => {
        setLoading(false);

        timeout = false;

        if (!res.success) {
          console.log("err 4");
          showError({msg:res.message})
          return {};
        }

        if (res.data.id===0) {
          console.log("err 3");

          showError({msg:"No Data",btns:[okBtn, refreshBtn]})
          return {};
        }

        var menus = res.data.menu;
        var pnls:any = {"000":{name:res.data.info?.inpLbl, expand:true, items:[]}};

        const a = await menus.map(async (menu:any,i:any) => {
          if (menu.type === "G") {
              const code = menu.code;
              menu.expand = true;
              menu.items = [];
              pnls[code] = menu;
          }
          menu.spcParam = JSON5.parse("{"+menu.spcParam+"}")
        })
      
        Promise.all(a).then(() => {
          menus.map((menu:any,i:any) => {
            if (menu.type !== "G") {
              var pname = "000";
              if (menu.parent) {
                pname = menu.parent;
              }
              const panel = util.getKeyValue(pname)(pnls);
              panel.items.push(menu);
              pnls[pname] = panel;
            }
          });

          setPanels(pnls)
        });

        return {info:res.data.info}
  },
  (error) => {
      timeout = false;
      console.log("err 2");
      setLoading(false);
      if (retry) {
        server.login((success:boolean, msg:string) => {
          if (success) {
            console.log("doFetchDtls success");
            doFetchDtls(server.state, false)
          } else {
            console.log("doFetchDtls err 2");
            showError({msg:msg})
          }
        });
      } else {
        console.log("doFetchDtls err 3");
        showError({msg:error})
      }
  })
  )
  .catch(e => {
    timeout = false;
    console.log("err 1:"+e);
    showError({msg:"Please check Internet Connection!",btns:[okBtn, refreshBtn]});
//    setErrColor("dark");
  })

  const resAll = {...res} as FormType
  return resAll;
}

const fetchWorkflows = async function() {
  console.log("fetchWorkflows()");
  setInfo({
    sepColor:"",
    inpLbl:""
  });

  const res = await doFetchDtls(state, true);

  setInfo(res.info);
}

useEffect(() => {

  console.log("Workflows : useEffect()");
  const p = util.getKeyValue("000")(panels)
  if (!p)
    if (!state.base64ticket) {
        server.login(async () => {
          state = server.state;
          fetchWorkflows();
        });
    } else {
      fetchWorkflows();
    }

}, [panels])

  var row: {}[];

 return (
    <IonPage>
      <IonHeader>
        <IonToolbar key={"toolbar_header"}>
          <IonButtons slot="start">
            <IonMenuButton />
            <OpenMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
          {loading ?(
                 <><IonSpinner slot="end" name="lines" color="primary"/><IonLabel slot="end">&nbsp;</IonLabel></>
          ):""}
          <IonButtons slot="end">
            <IonButton hidden={loading} onClick={e => {setPanels({})}}><IonIcon icon={refresh}></IonIcon></IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar key={"toolbar_content"}>
            <IonTitle>{name}</IonTitle>
          </IonToolbar>
        </IonHeader>

        {Object.keys(panels).map((key:any,j:any) => {
            const panel = util.getKeyValue(key)(panels)
            //console.log("panel:("+key+","+j+"):"+panel.id);
            //console.log("items.length:"+panel.items.length);
            if (panel.items.length>0) {
            return (
              <IonList key={"list_"+key}>
                <IonItem key={"item_"+j} color={panel.spcParam?.color ? panel.spcParam.color : "primary"} className="itemStable" onClick={(e) => {panel.expand = !panel.expand;setPanels(prevState => ({...prevState, [key]:panel}))}}>
                  <IonIcon icon={panel.expand ? chevronDown : chevronForward}/>
                  <IonLabel>{panel.name}</IonLabel>
                </IonItem>

                <IonGrid>
                {panel.items?.map((item:any,i:any) => {

                  if (i % 2 === 0) {
                    row = []
                  }

                  var spcParam = item.spcParam
                  spcParam = (typeof spcParam === 'object' && spcParam !== null) ? spcParam : JSON.parse("{"+spcParam+"}");

                  var col = (
                      <IonCol key={"col_"+i} className="ion-text-center">
                          <IonButton strong={true} className="btn" size="large" color={spcParam.color ? spcParam.color : "success"}  onClick={e=>{
    //                        console.log("-"+item.name+", item.spcParam:"+item.spcParam)
                            e.preventDefault();
                            server.lastUrl = {
                              pathname: "/page/home/workflows/workflow/"+item.id+"/"+item.hid+"/"+item.name,
                              state: { 
                                canCreate : spcParam.action?.indexOf("C")>=0,
                                canEdit : spcParam.action?.indexOf("E")>=0,
                                canCopy : spcParam.action?.indexOf("O")>=0
                              }
                            }
                            console.log("workflows : onClick():lastUrl:"+server.lastUrl)
                            history.replace(server.lastUrl.pathname, server.lastUrl.state)
                          }}>
                          <div>
                          <IonAvatar>
                          {item.showIcon ?
                          spcParam.icon ?
                          (<ImageWithAuth src={server.getApiUrl()+"node/"+util.getNodeRefStr(spcParam.icon)+"/content/thumbnail/avatar?c=force"}/>)
                          :
                          item.name.substring(0,1).match("^[a-zA-Z0-9]*$") ?
                          (<ImageWithAuth src={server.getPrefixUrl()+"util/letterIcon?letter="+item.name.substring(0,1).toUpperCase()}/>)
                          :
                          (<img src="/assets/img/workflow.png" />)
                          :
                          (<img src="/assets/img/workflow.png" />)
                          }
                          </IonAvatar>
                          </div>
                          </IonButton>
                          <IonLabel className="lbl"><br/>{item.name}</IonLabel>
                      </IonCol>
                  )

                  row.push(col)
                   
                  if (i===panel.items.length-1 || (i % 2 === 1)) {
                    return (
                      <IonRow hidden={!panel.expand}>
                        <>{row}</>
                      </IonRow>
                    )
                  }
                })}
                </IonGrid>
            
            </IonList>
            )
          }
        })}

      </IonContent>
    </IonPage>
  );
};

export default withRouter(Workflows);
